import React, { Component } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DatePicker from 'material-ui/DatePicker';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';
import * as formatter from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import moment from 'moment';

import SearchableSelect from 'components/shared/SearchableSelect';

const labelStyle = {
  transform: 'scale(0.75) translateY(15px)',
  transformOrigin: 'left top 0px',
  color: colors.LABEL_GRAY,
  float: 'left',
  margin: 0,
};

class TicketTimePickerDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scheduledStartsAt: props.initScheduledStartsAt,
      scheduledDuration: hostIsCapreit() ? 4 : 0.5,
      scheduledStartsAtTime: '9:00 AM',
      assignTo: {},
      showScheduledTimeError: false,
    };
  }

  UNSAFE_componentWillReceiveProps = newProps => {
    if (newProps.initScheduledStartsAt !== this.props.initScheduledStartsAt) {
      this.setState({
        scheduledStartsAt: newProps.initScheduledStartsAt,
        scheduledStartsAtTime: moment(newProps.initScheduledStartsAt).format('LT'),
      });
    }
  };

  changeScheduledDuration = (_e, _index, newValue) => {
    this.setState({ scheduledDuration: newValue });
  };

  changeScheduledAt = datetime => {
    this.setState({
      scheduledStartsAt: datetime,
    });
  };

  changeScheduledStartsAtTime = time => {
    const selectedTime = time.target.innerText;
    this.setState({
      scheduledStartsAtTime: selectedTime,
    });
  };

  changeAssignTo = assignTo => {
    this.setState({ assignTo });
  };

  convertToTwentyFourHour = selectedTime => {
    const hourString = selectedTime.substring(0, 2);

    const isPM = selectedTime.substring(5, 7) === 'PM';
    if (isPM) {
      return parseInt(hourString, 10) + 12;
    }

    return hourString;
  };

  saveTicket = () => {
    if (!this.state.scheduledStartsAtTime) {
      return;
    }

    const selectedTime = this.state.scheduledStartsAtTime;

    const scheduledStartsAt = moment(
      formatter.combineDateAndTime(
        formatter.toISO8601DateString(this.state.scheduledStartsAt),
        selectedTime
      )
    );

    const scheduledEndsAt = moment(scheduledStartsAt).add(this.state.scheduledDuration, 'hours');

    this.props.scheduleTicket(
      this.props.ticketId,
      true,
      scheduledStartsAt.toDate(),
      scheduledEndsAt.toDate(),
      this.state.assignTo
    );
    this.props.closeDialog();
  };

  render() {
    const durationOptions = this.props.companyPreferences.ticket_scheduling_durations || [];

    return (
      <Dialog disableBackdropClick open={this.props.open}>
        <DialogTitle>
          <h3 style={{ textAlign: 'center', margin: 0 }}>
            {getTranslatedString('landlordPortal.landlordTicketScheduler.pickATime')}
          </h3>
        </DialogTitle>
        <DialogContent style={{ padding: '0 15px 15px' }}>
          <div className="row">{this._renderTimeSelect()}</div>
          <div className="row">
            <div className="col-sm-6">
              <label style={labelStyle}>
                {getTranslatedString('landlordPortal.landlordTicketScheduler.duration')}
              </label>
              <SelectField
                fullWidth
                value={this.state.scheduledDuration}
                onChange={this.changeScheduledDuration}
                style={{ fontSize: '14px' }}
              >
                {durationOptions.map(option => {
                  return (
                    <MenuItem
                      key={`option_${option}`}
                      value={option}
                      primaryText={`${option} ${getTranslatedString(
                        'landlordPortal.landlordTicketScheduler.hour'
                      )}`}
                    />
                  );
                })}
              </SelectField>
            </div>
            <div className="col-sm-6" style={{ marginTop: '24px' }}>
              <SearchableSelect
                onChange={this.changeAssignTo}
                filter={(searchText, key) => key.indexOf(searchText) !== -1}
                fullWidth
                grouped
                options={this.props.maintenanceStaff}
                placeholder={getTranslatedString('landlordPortal.landlordTicketScheduler.assignTo')}
                style={{ marginTop: '25px' }}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions style={{ display: 'block', padding: '0 0.5rem' }}>
          <FlatButton onClick={this.props.closeDialog} style={{ color: AccentColor() }}>
            {getTranslatedString('landlordPortal.landlordTicketScheduler.cancel')}
          </FlatButton>
          <FlatButton
            variant="raised"
            onClick={this.saveTicket}
            style={{
              float: 'right',
              color: 'white',
              backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
            }}
          >
            {getTranslatedString('landlordPortal.landlordTicketScheduler.save')}
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }

  _renderTimeSelect = () => {
    const startTimeOptions = this.props.companyPreferences.ticket_scheduling_starts_at_times || [];

    return (
      <div className="row">
        <div className="col-sm-6" style={{ marginTop: 19 }}>
          <DatePicker
            name="scheduled_starts_at_date"
            component={DatePicker}
            formatDate={formatter.reformatDate}
            floatingLabelText={getTranslatedString(
              'landlordPortal.landlordTicketScheduler.startDate'
            )}
            fullWidth
            onChange={(e, date) => this.changeScheduledAt(date)}
            value={this.state.scheduledStartsAt}
            style={{ marginTop: '-19px', fontSize: '14px' }}
            minDate={new Date()}
          />
        </div>
        <div className="col-sm-6">
          <SelectField
            fullWidth
            name="scheduled_starts_at_time"
            component={SelectField}
            floatingLabelText={getTranslatedString(
              'landlordPortal.landlordTicketScheduler.startTime'
            )}
            style={{ fontSize: '14px' }}
            textFieldStyle={{ fontSize: '14px' }}
            onChange={this.changeScheduledStartsAtTime}
            value={this.state.scheduledStartsAtTime}
            errorText={!this.state.scheduledStartsAtTime && 'required'}
          >
            {startTimeOptions.map(option => (
              <MenuItem key={`start_time_${option}`} value={option} primaryText={option} />
            ))}
          </SelectField>
        </div>
      </div>
    );
  };
}

export default TicketTimePickerDialog;
